import styled from "styled-components";
import { colors } from "../../assets";

export const HealthInsuredContainer = styled.div`
.selectBox {
    height: auto;
    margin-bottom: 20px;
}

.beneficiaries-table{
    margin-top: 20px;
}

.col-10 {
    width: 10%;
}
.col-15 {
    width: 15%;
}
.col-20 {
    width: 20%;
}
.col-25 {
    width: 25%;
}
.col-2 {
    width: 20%;
}
.col-30 {
    width: 30%;
}
.col-35 {
    width: 35%;
}
.col-40 {
    width: 40%;
}
.col-50 {
    width: 50%;
}
.col-60 {
    width: 60%;
}
.col-70 {
    width: 70%;
}
.result-simulation-special-row {
    width: 100%;
    display: flex;
    float: left;
    margin-bottom: 20px;
}

.group {
    display: flex;

    &-name {
        margin-bottom: 15px;
    }

    &-checkmark {
        background: ${colors["primaryColor"]};
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        min-width: 20px;
        height: 20px;
        padding: 2px;
        margin-right: 14px;
        margin-left: 2px;
        border-radius: 3px;

        img {
            max-width: 14px;
        }
    }

    .checkbox-container {
        white-space: initial;
    }
}
`;
